var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgUserFilledIcon = function SvgUserFilledIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 16A8 8 0 1 0 8 0a8 8 0 0 0 0 16Zm2.774-9.929c0 1.554-1.238 2.822-2.774 2.822S5.226 7.625 5.226 6.07C5.226 4.518 6.464 3.25 8 3.25s2.774 1.268 2.774 2.821ZM8 14.5c1.96 0 3.719-.868 4.91-2.241a1.49 1.49 0 0 0-.313-.389A6.88 6.88 0 0 0 8 10.107a6.898 6.898 0 0 0-4.952 2.103A6.486 6.486 0 0 0 8 14.5Z",
    fill: "#currentColor"
  })));
};

export default SvgUserFilledIcon;